// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
/* eslint-disable camelcase */

import { createAsyncAction } from 'typesafe-actions';

export interface UpdateViewHistoryRequestPayload {
  id: number;
}
export interface UpdateViewHistorySuccessPayload {
}

export interface UpdateViewHistoryFailPayload {
  error: Error;
}

export const updateViewHistoryActions = createAsyncAction(
  'elearning/UPDATE_VIEW_HISTORY',
  'elearning/UPDATE_VIEW_HISTORY_SUCCESS',
  'elearning/UPDATE_VIEW_HISTORY_FAIL'
)<
  UpdateViewHistoryRequestPayload,
  UpdateViewHistorySuccessPayload,
  UpdateViewHistoryFailPayload
>();
